// extracted by mini-css-extract-plugin
export var active = "_2s-j";
export var cell = "_2s-3";
export var cellLoading = "_2s-6";
export var center = "_2s-10";
export var clickable = "_2s-c";
export var compact = "_2s-4";
export var container = "_2s-8";
export var data = "_2s-a";
export var dataRow = "_2s-b";
export var dateRangeContainer = "_2s-2";
export var downloadIcon = "_2s-v";
export var empty = "_2s-e";
export var filter = "_2s-g";
export var filterContainer = "_2s-16";
export var filterCount = "_2s-i";
export var filterLabel = "_2s-h";
export var filters = "_2s-f";
export var header = "_2s-l";
export var headerButton = "_2s-m";
export var headerContent = "_2s-n";
export var headerLabel = "_2s-p";
export var headerRow = "_2s-u";
export var headerSort = "_2s-o";
export var headerSortAsc = "_2s-r";
export var headerSortContainer = "_2s-q";
export var headerSortDesc = "_2s-s";
export var headerSpacer = "_2s-t";
export var headers = "_2s-w";
export var infoIcon = "_2s-1b";
export var left = "_2s-z";
export var loader = "_2s-y";
export var loaderContainer = "_2s-x";
export var main = "_2s-9";
export var movingGradient = "_2s-7";
export var options = "_2s-0";
export var pageChangeButton = "_2s-1a";
export var pageControl = "_2s-17";
export var pageControlSticky = "_2s-18";
export var pageNumbers = "_2s-19";
export var right = "_2s-11";
export var seamless = "_2s-1";
export var spacer = "_2s-12";
export var table = "_2s-14";
export var tableContainer = "_2s-13";
export var tableFitToParent = "_2s-15";
export var textHeader = "_2s-k";
export var title = "_2s-d";
export var wide = "_2s-5";